import { Layout } from '@/components/Layout/Layout';
import ClientInspirationSlugPage from 'components/PageLevelComponents/ClientInspirationSlugPage';
import { ANONYMOUS_TOKEN_NAME, LOCALE_DEFAULT } from 'config/config';
import type { GetServerSideProps } from 'next';
import { InspirationPageController } from 'server/controller/page/inspiration/inspirationPageController';
import type { IInspirationPageResource } from 'server/resource/page/inspirationPageResource';
import type { IGlobalMetaData } from 'types/IGlobalMetaData';

export default function Page(props: IInspirationPageResource) {
  const {
    metaData,
    data,
    breadcrumbsCMSData,
    difficultyCopy,
    searchOverlayData,
    searchItemLabels,
    recipeCopy,
    footerNavData,
    footerImage,
    countrySelectorData,
    newsletterData,
    contactUsUrl,
    getHeaderNav,
    getMobileNavData,
    popularSearchData,
    cardCarouselCMSData,
    recallData,
    locale,
    pathTranslations,
    userToken,
    globalDictionary,
  } = props;

  return (
    <Layout
      themeName={data?.genericPages.at(0)?.theme || ''}
      pathTranslations={pathTranslations}
      locale={locale}
      globalMetadata={metaData}
      getHeaderNav={getHeaderNav}
      getMobileNavData={getMobileNavData}
      popularSearchData={popularSearchData}
      footerNavData={footerNavData}
      footerImage={footerImage}
      searchOverlayData={searchOverlayData}
      countrySelectorData={countrySelectorData}
      newsletterData={newsletterData}
      contactUsUrl={contactUsUrl}
      difficultyCopy={difficultyCopy as Record<string, string>}
      cardCarouselCMSData={cardCarouselCMSData}
      recallData={recallData}
      userToken={userToken}
      globalDictionary={globalDictionary}
    >
      <ClientInspirationSlugPage
        data={data}
        breadcrumbsCMSData={breadcrumbsCMSData}
        globalMetadata={metaData as IGlobalMetaData}
        searchItemLabels={searchItemLabels as Record<string, string>}
        searchOverlayData={searchOverlayData}
        recipeCopy={recipeCopy}
        difficultyCopy={difficultyCopy as Record<string, string>}
        themeName={data?.genericPages.at(0)?.theme || ''}
      />
    </Layout>
  );
}

export const getServerSideProps: GetServerSideProps = async ({
  locale,
  params,
  defaultLocale,
  resolvedUrl,
  req,
}) => {
  const anonymousToken = req.cookies[ANONYMOUS_TOKEN_NAME];
  return InspirationPageController.getCachedInspirationPageData({
    resolvedUrl,
    locale: locale || defaultLocale || LOCALE_DEFAULT,
    slug: Array.isArray(params?.slug) ? params.slug : [],
    userToken: anonymousToken ?? '',
  });
};
